import React, { useMemo } from 'react';
import styled from 'styled-components';
import { EventConditions } from '../../../../components/Builder/BuilderFields';
import { IRowMeta } from '../../../../redux/slices/oldBuilder';
import {
  HighlightedEntity,
  withHighlightingContext,
} from '../../../../components/HighlightingContext';
import {
  useActionsVisibilityContext,
  withActionsVisibilityContext,
} from '../../../../components/ActionsVisibilityContext';
import DndDroppableZone from '../../../../components/DndEntity/DndDroppableZone';
import { createDictionaryEntityDropzoneId } from '../../../../components/DndEntity/utils';
import { EntityDropzoneType } from '../../../../components/QuickAccessDictionary/DictionaryTabs/types';
import { isEmptyEventConditions } from '../../../../utils/builder';
import { useAppSelector } from '../../../../redux/hooks';
import { eventConditionsPrimitiveSelector } from '../../../../redux/selectors/builder';
import {
  EntityDropzoneDataTypeEnum,
  IEventEntityDropzoneDataType,
} from '../../../../components/DndEntity/validation';
import { MAX_EVENT_CONDITIONS_COUNT } from '../../../../config/constants';
import { borderedContent } from '../../../../styles/shareableStyles';

interface IProps {
  rowMeta: IRowMeta;
  label: string;
}

const Container = styled(HighlightedEntity)`
  padding: 8px;
  ${borderedContent};
`;

const Label = styled.div`
  width: 116px;
  text-align: right;
`;

const RetentionConditions = ({ rowMeta, label }: IProps) => {
  const { showActions, hideActions } = useActionsVisibilityContext();
  const eventConditionsSelector = useMemo(eventConditionsPrimitiveSelector, []);
  const eventConditions = useAppSelector((state) =>
    eventConditionsSelector(state, rowMeta),
  );
  const eventDropzoneId = createDictionaryEntityDropzoneId(
    EntityDropzoneType.Events,
    rowMeta,
  );

  const areEventConditionsEmpty = isEmptyEventConditions(eventConditions);

  return (
    <DndDroppableZone
      accepts={[EntityDropzoneType.Events]}
      id={eventDropzoneId}
      data={
        {
          id: eventDropzoneId,
          type: EntityDropzoneDataTypeEnum.Events,
          rowMeta: {
            ...rowMeta,
            eventIndex: areEventConditionsEmpty ? 0 : eventConditions.length,
          },
          isNewEvent: !areEventConditionsEmpty,
          shouldAddMeasureFunction: areEventConditionsEmpty,
        } satisfies IEventEntityDropzoneDataType
      }
      customMessage={`+ Add Event to ${label}`}
      hasError={eventConditions.length >= MAX_EVENT_CONDITIONS_COUNT}
    >
      <Container onMouseEnter={showActions} onMouseLeave={hideActions}>
        <EventConditions rowMeta={rowMeta} label={<Label>{label}</Label>} />
      </Container>
    </DndDroppableZone>
  );
};

export default withHighlightingContext(
  withActionsVisibilityContext(RetentionConditions),
);
